import React from 'react'
import { InputNumber } from 'antd'
import { TagsSelector } from './tags-selector'

export function GrapesSelector({ value = [], onChange, onEditPercentage }) {
  return (
    <>
      <TagsSelector
        tagsType="uva"
        value={value.map((v) => v.id)}
        onChange={onChange}
      />
      {value.length > 0 && (
        <>
          <div style={{ fontSize: 12, margin: '20px 0 0 10px' }}>
            Percentages:
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {value.map((grape, index) => (
              <InputNumber
                key={grape.id}
                min={0}
                formatter={(value) => `${grape.id}: ${value}%`}
                style={{ margin: 10, width: 400 }}
                max={100}
                value={grape.otros_datos.porcentaje}
                onChange={(porcentaje) =>
                  onEditPercentage(
                    value.map((g, i) =>
                      i === index ? { ...g, otros_datos: { porcentaje } } : g
                    )
                  )
                }
                onInput={(txt) => {
                  const porcentaje = parseInt(
                    txt.split(':')[1].replace('%', '').trim(),
                    10
                  )
                  onEditPercentage(
                    value.map((g, i) =>
                      i === index ? { ...g, otros_datos: { porcentaje } } : g
                    )
                  )
                }}
              />
            ))}
          </div>
        </>
      )}
    </>
  )
}
